<div class="container">
  <div class="logo">
    <img src="assets/img/logo-WAPI.png" alt="Logo WAPI" />
  </div>
</div>
